/**
 * @file components/RelatedStory/component.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 */

import PropTypes from "prop-types";
import RelatedItem from "../RelatedItem/component";

/**
 * The RelatedExternal component.
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the RelatedExternal component
 */
export function RelatedExternal(props) {
    const relatedMarkup = props.links.map((item) => (
        <RelatedItem
            key={`${item.title}-${item.url}`}
            {...item}
            external={true}
        />
    ));

    return (
        <div className="relatedExternal" data-testid="relatedExternal">
            {relatedMarkup}
        </div>
    );
}

RelatedExternal.propTypes = {
    links: PropTypes.array.isRequired,
};

export default RelatedExternal;
